import { Node, Plugin } from 'tiptap'
import { nodeInputRule, TextSelection} from "prosemirror-state"
import File from "./File.vue";

/**
 * Matches following attributes in Markdown-typed image: [, alt, src, title]
 *
 * Example:
 * ![Lorem](image.jpg) -> [, "Lorem", "image.jpg"]
 * ![](image.jpg "Ipsum") -> [, "", "image.jpg", "Ipsum"]
 * ![Lorem](image.jpg "Ipsum") -> [, "Lorem", "image.jpg", "Ipsum"]
 */
const IMAGE_INPUT_REGEX = /!\[(.+|:?)\]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/

export default class UploadFile extends Node {

  get name() {
    return 'uploadfile'
  }

  get schema() {
    return {
      inline: false,
	  selectable: true,
	  marks: "",
	  allowGapCursor: false,
	  group: 'block',
      draggable: true,
	  atom: true,
	  
      attrs: {
        href: {
          default: null,
        },
        linkText: {
          default: "file"
        },
        // target: {
        //   default: "_blank"
        // },
		class: {
			default: "upload-file"
		},
		attached: {
			default: ""
		},
		uuid: {
			default: ""
		},
		size: {
			default : ""
		}

      },
      
      parseDOM: [
        {
          tag: 'a[href]',
          getAttrs: dom => ({
            src: dom.getAttribute('href')
          }),
        },
      ],
      toDOM: node => ['a', {
        ...node.attrs,
        rel: 'noopener noreferrer nofollow',
      }, node.attrs.linkText],
    }
  }

  commands({ type }) {
    return {
		createUploadFile:
			attrs => (state, dispatch) => {
			const { selection } = state
			const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
			const node = type.create(attrs)
			var resolved = state.doc.resolve(position)
			
			//if we are in a empty paragraph replace it
			//otherwise we just insert the image
			if(resolved.parent&&resolved.parent.type.name=="paragraph"&&resolved.parent.content.size==0){
				var transaction = state.tr.replaceWith(position-1,position,node)
				transaction.setSelection(new TextSelection(transaction.doc.resolve(position)))
	
				dispatch(transaction)
			}else{
				var endPos = state.doc.content.size;
				var newPosition = position <= endPos ? position : endPos;
				var cursorPosition = position + 1 <= endPos ? position + 1 : endPos;
				var transaction = state.tr.insert(newPosition, node)
				transaction.setSelection(new TextSelection(transaction.doc.resolve(cursorPosition)))
				dispatch(transaction)
			}
		
				
		},

		renameUploadFile: ({linkText}) => (state, dispatch) => {
			var attrs = {
				linkText: linkText,
				href: state.selection.node.attrs.href,
				class: state.selection.node.attrs.class,
				attached: state.selection.node.attrs.attached,
			}
			
			const position = state.selection.anchor;
	
			var transaction = state.tr.setNodeMarkup(position,undefined ,attrs);
	
			dispatch(transaction);
		},
	  }
  }


	get view() {
		return File;
	}


}
